export const GET_CURRICULUM_AI_MENTOR_USER_DATA =
  'GET_CURRICULUM_AI_MENTOR_USER_DATA'
export const GET_CURRICULUM_AI_MENTOR_USER_DATA_SUCCESS =
  'GET_CURRICULUM_AI_MENTOR_USER_DATA_SUCCESS'
export const GET_CURRICULUM_AI_MENTOR_USER_DATA_FAILURE =
  'GET_CURRICULUM_AI_MENTOR_USER_DATA_FAILURE'
export const GET_CURRICULUM_AI_MENTOR_USER_DATA_CANCEL =
  'GET_CURRICULUM_AI_MENTOR_USER_DATA_CANCEL'
